import { eventBus } from '@eventBus'
import cSocket from './cSocket'

export default {
    data() {
        return {
            chat_socket: null,
        }
    },
    methods: {
        chat_initSocket() {
            this.chat_socket = new cSocket({
                wss: 'wss://new-8000.fleetsoft.pro',
                token: this.user.token,
                name: 'new-8000',
                onmessage: this.chat_onmessage,
            })
            eventBus.$on('socketEmit_chat', this.chat_socket.emit.bind(this.chat_socket))
        },
        chat_onmessage(action, data) {
            console.warn('new-8000 chat_onmessage:', { action, data })
            const counter = data.counter
            if(counter) {
                eventBus.$emit('socketUpdateCounter', counter)
            }
            switch (action) {
                case 'update_counter':
                    eventBus.$emit('socketUpdateCounter', data)
                    break
                case 'personal_message':
                    eventBus.$emit('socketMessage', data)
                    break
                case 'change_message':
                    eventBus.$emit('socketChangeMessage', data)
                    break
                case 'new_chat':
                    eventBus.$emit('socketNewСhat', data)
                    break
                case 'assign_end_message':
                    eventBus.$emit('socketAssignEndMessage', data)
                    break
                case 'close':
                    break
                case 'return_to_list':
                    break
                case 'assign_to_operator':
                    eventBus.$emit('socketRemoveChat', data)
                    break
                default:
                    break
            }
        },
    },
}
